import { render } from "./ChecklistPanel.vue?vue&type=template&id=470c8dee&scoped=true"
import script from "./ChecklistPanel.vue?vue&type=script&lang=js"
export * from "./ChecklistPanel.vue?vue&type=script&lang=js"

import "./ChecklistPanel.vue?vue&type=style&index=0&id=470c8dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470c8dee"]])

export default __exports__